import { HhsgSharedTrackingBase } from './tracking-base.model';
import { HhsgSharedPasswordComplexity } from './password-complexity.model';
import { HhsgSharedExcludedPassword } from './excluded-password.model';
import { HhsgSharedSsoSettings } from './sso-settings.model';

export class HhsgSharedCorporation extends HhsgSharedTrackingBase {
	constructor() {
		super();
		this.ssoSettings = [];
	}

	loginPageText: string;
	fullLogoPath: string;
	loginMethod: string;	
	maximumPasswordAge: number;
	maximumDormantDays: number;
	forceTLSWhenSendingEmail: boolean;
	useAcceleratorsAuthentication: boolean;
	useAcceleratorsEmail: boolean;
	loginUrlAppendix: string;
	accountLockoutDurationMinutes: number;
	maxFailedSignInAttempts: number;
	passwordExpirationMessageDays: number;
	sessionTimeoutMinutes: number;
	removeExistingLogo: boolean;
	passwordComplexity: HhsgSharedPasswordComplexity;
	excludedPasswords: HhsgSharedExcludedPassword[];
	ssoSettings: HhsgSharedSsoSettings[];
	passwordRecoveryChallengeCount: number;
	passwordRecoveryAnswersCount: number;
	isHuronCorporation: boolean;
}
